module.exports = __webpack_public_path__ + "img/logo_poch.9ed9b92f.png";